import { createElement, forwardRef, memo } from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import ButtonComponent from "./ButtonComponent";

import SetState from "typings/SetState";

type DateTimePickerProps = {
  date: Date;
  setDate: SetState<Date>;
  label: string;
};

const DateTimePicker = ({ date, setDate, label }: DateTimePickerProps) => {
  const ExampleCustomInput = (
    {
      value,
      onClick,
    }: {
      value: string;
      onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    },
    ref: any
  ) => (
    <ButtonComponent
      className="bg-white text-black"
      style={{ borderColor: "#ced4da" }}
      onClick={onClick}
      refProps={ref}
    >
      {label}: {value}
    </ButtonComponent>
  );

  return (
    <DatePicker
      selected={date}
      onChange={(date: Date) => setDate(date)}
      showTimeSelect
      dateFormat="Pp"
      customInput={createElement(forwardRef(ExampleCustomInput))}
    />
  );
};

export default memo(DateTimePicker);
